import { useTranslation } from "react-i18next";
import ListPage from "../../../layouts/page/ListPage";
import { Columns } from "./Columns";
import MenuConfig from "../../../../constants/MenuConfig";
import Api from "../../../../constants/Api";

const ReasonList = () => {

    const { t } = useTranslation();
    return (
        <ListPage
            showPageTitle="true"
            activeMenu={t("reasons_cancellation")}
            motherMenu={t("sales")}
            path={Api.sales.reason}
            route={MenuConfig.sales.reason.route}
            columns={Columns}
        />
    );
}

export default ReasonList;